import { Container, Section } from "@/components/ui/section";
import { Link } from "react-router-dom";
import { Linkedin, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <Section id="footer" className="bg-muted/30 border-t border-border">
      <Container>
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Left column */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-2">tellcasey</h3>
            <p className="text-sm text-muted-foreground">
              AI-powered customer interviews and storytelling at scale.
            </p>
          </div>

          {/* Navigation column */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><a href="#product" className="text-sm text-muted-foreground hover:text-primary transition-colors">Product</a></li>
              <li><a href="#how-it-works" className="text-sm text-muted-foreground hover:text-primary transition-colors">How it works</a></li>
              <li><a href="#use-cases" className="text-sm text-muted-foreground hover:text-primary transition-colors">Use cases</a></li>
              <li><a href="#pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">Pricing</a></li>
              <li><a href="#examples" className="text-sm text-muted-foreground hover:text-primary transition-colors">Samples</a></li>
              <li><a href="#faq" className="text-sm text-muted-foreground hover:text-primary transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Resources column */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/guides/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/glossary/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Glossary
                </Link>
              </li>
              <li>
                <Link to="/templates/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Templates
                </Link>
              </li>
              <li>
                <Link to="/playbooks/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Playbooks
                </Link>
              </li>
              <li>
                <Link to="/faq/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/llm-snippets/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  LLM Snippets
                </Link>
              </li>
              <li>
                <Link to="/what-is-customer-proof-automation/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Customer Proof Automation
                </Link>
              </li>
              <li>
                <Link to="/resources/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Resource Library
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Contact column */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/terms-of-service" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/acceptable-use" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Acceptable Use
                </Link>
              </li>
              <li>
                <Link to="/legal/dpa" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Data Processing Addendum
                </Link>
              </li>
            </ul>
            <h4 className="text-sm font-semibold text-foreground mb-4 mt-6">Contact</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/early-access" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Book a demo
                </Link>
              </li>
              <li>
                <a href="mailto:hello@tellcasey.com" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  hello@tellcasey.com
                </a>
              </li>
            </ul>
            <h4 className="text-sm font-semibold text-foreground mb-4 mt-6">Follow Us</h4>
            <div className="flex gap-3">
              <a 
                href="https://www.linkedin.com/company/tellcasey/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Follow tellcasey on LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://www.facebook.com/tellcaseyinc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Follow tellcasey on Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-border text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} tellcasey. All rights reserved.
          </p>
        </div>
      </Container>
    </Section>
  );
};
